export default {
  hero: {
    badge: "Tienda Digital",
    titlePrefix: "Productos & ",
    titleHighlight: "Ofertas",
    subtitle: "Cursos, productos digitales, talleres y servicios diseñados para llevar tu negocio al siguiente nivel."
  },
  categories: {
    all: "Todos",
    courses: "Cursos",
    products: "Productos Digitales",
    workshops: "Talleres",
    services: "Servicios"
  },
  grid: {
    foundSingle: "producto encontrado",
    foundPlural: "productos encontrados"
  },
  common: {
    buyNow: "Comprar Ahora",
    enroll: "Inscribirme",
    book: "Reservar",
    hire: "Contratar",
    new: "Nuevo",
    popular: "Popular",
    bestSeller: "Más Vendido"
  },
  footerCta: {
    title: "¿No encuentras lo que buscas?",
    subtitle: "Agenda una consultoría gratuita y te ayudamos a encontrar la solución perfecta para tu negocio.",
    cta: "Agendar Consultoría Gratis"
  },
  items: {
    m1: { badge: "Más Vendido", desc: "Aprende a crear contenido viral y hacer crecer tu audiencia en Instagram, TikTok y Facebook desde cero." },
    m2: { desc: "Domina herramientas de IA para automatizar tu negocio y multiplicar tus ingresos." },
    m3: { title: "Marketing Digital desde Cero", desc: "Curso completo para emprendedores que quieren aprender marketing digital y hacer crecer su negocio." },
    m4: { desc: "Plantilla profesional de calendario de contenido para planificar 30 días de publicaciones." },
    m5: { title: "Kit de Marca Completo", desc: "Kit de marca digital con plantillas de Canva, guía de colores y tipografías para tu negocio." },
    m6: { title: "Pack de Captions para Instagram", desc: "200 captions listos para usar que generan interacción y ventas para tu negocio." },
    m7: { title: "Workshop: Lanza Tu Negocio", badge: "En Vivo", desc: "Taller en vivo de 3 horas para lanzar tu negocio digital desde cero con estrategia." },
    m8: { desc: "Aprende a construir tu lista de correos y crear campañas que generen ventas automáticas." },
    m9: { title: "Workshop: Branding Personal", badge: "Próximamente", desc: "Construye una marca personal poderosa que te posicione como experto en tu industria." },
    m10: { title: "Consultoría 1:1", desc: "Sesión privada de 60 minutos para revisar tu estrategia digital y crear un plan de acción." },
    m11: { title: "Gestión de Redes Sociales", desc: "Servicio mensual completo de manejo de redes sociales con estrategia y contenido." },
    m12: { title: "Diseño de Sitio Web", desc: "Diseño y desarrollo profesional de sitios web en Wix con estrategia de conversión incluida." }
  }
};
